






import Vue from "vue";
import {
  createComponent,
  ref,
  onUnmounted,
  provide,
} from "@vue/composition-api";
import { megaraxClientKey } from "../shared/useMegaraxClient";
import megaraxClient from "@/megaraxClient";
import { User } from "@megarax/client/src/resources/iam";
import { getErrorMessage } from "@/i18n/errors";

const authResponseRefreshMarginMs = 30000;

export default createComponent({
  setup(props, ctx) {
    provide(megaraxClientKey, megaraxClient);

    const signedIn = ref(megaraxClient.signedIn);

    megaraxClient.setErrorHandler((errors: any, statusCode: any) => {
      console.log(errors);
      if (errors) {
        errors.forEach((error: any) => {
          ctx.root.$notify.error({
            title: error.field || statusCode,
            message: getErrorMessage(error),
          });
        });
      } else {
        ctx.root.$notify.error({
          message: "Wystąpił błąd.",
          title: statusCode,
        });
      }
    });

    onUnmounted(() => {
      //logout
      megaraxClient.signOut();
    });

    async function idTokenProvider(): Promise<string> {
      const user = gapi.auth2.getAuthInstance().currentUser.get();
      const currentResponse = user.getAuthResponse();
      const timeLeft = currentResponse.expires_at - Date.now();
      if (timeLeft < authResponseRefreshMarginMs) {
        const newResponse = await user.reloadAuthResponse();
        return newResponse.id_token;
      }
      return currentResponse.id_token;
    }

    if (!signedIn.value) {
      megaraxClient.signIn(idTokenProvider).then((user) => {
        signedIn.value = !!user;
      });
    }

    return { signedIn };
  },
});
